import React, { useContext } from "react";

import NextImage from "next/legacy/image";
import styled from "styled-components";

import ComponentContext from "../../../contexts/ComponentContext";
import Markdown from "../../styles/Markdown";

const ImageContainer = styled.div`
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  max-width: 100%;
  max-height: 100%;
  ${(props) => props.dynamicStyles || ""}
`;

const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: white;
  padding: 10px;
  font-size: 18px;
`;

function Image() {
  const { image, text, CSS } = useContext(ComponentContext);

  if (!image) {
    return null;
  }

  if (!text) {
    return (
      <NextImage
        alt={image?.alternativeText}
        height={image.height}
        src={image?.url}
        width={image.width}
      />
    );
  }

  const { height, width } = image;

  return (
    <ImageContainer dynamicStyles={CSS} height={height} width={width}>
      <NextImage
        alt={image?.alternativeText}
        height={image.height}
        src={image?.url}
        width={image.width}
      />
      {text && (
        <ImageOverlay>
          <Markdown className="h-100">{text}</Markdown>
        </ImageOverlay>
      )}
    </ImageContainer>
  );
}

export default Image;
